import { Injectable } from '@angular/core';
import { Observable } from 'rxjs';
import { map } from 'rxjs/operators';

import { ApiService } from '../api-service/api.service';

@Injectable()
export class TermsOfServiceService {
  constructor(private api: ApiService) {}

  get termsOfService(): Observable<any> {
    return this.api.get('/_ajax/v1/terms-of-service/').pipe(map((res) => res.terms));
  }

  acceptTermsOfService(): Observable<boolean> {
    return this.api.post('/_ajax/v1/accept-terms-of-service', {});
  }
}
